import { canAccessRoute } from '@/features/auth/access-control/routeAccess';
import { SECTION_CHILD_PATHS } from '@/features/navigation/sidebar/sidebar.config';

type Perms = {
  canAny: (keys: readonly string[]) => boolean;
};

export function normalizePath(path?: string): string {
  return (path ?? '').replace(/\/$/, '');
}

export function sectionIsVisible(sectionPath: string, perms: Perms): boolean {
  const children = SECTION_CHILD_PATHS[sectionPath];
  return children?.some((path) => canAccessRoute(path, perms)) ?? false;
}

export type SubMenuItem = {
  id: string;
  path?: string;
  icon?: React.ComponentType<{ className?: string }>;
  meta?: { group?: string };
};

export function getVisibleSubMenuItems(items: readonly SubMenuItem[], perms: Perms): SubMenuItem[] {
  return items.filter((item) => canAccessRoute(normalizePath(item.path), perms));
}
